'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nestedtypes = require('nestedtypes');

var Nested = _interopRequireWildcard(_nestedtypes);

var _callClassFactory = require('@unitedtraders/nested-hateoas/dist/rpc/callClassFactory');

var _MethodType = require('@unitedtraders/nested-hateoas/dist/rpc/MethodType');

var _serverErrors = require('@unitedtraders/nested-hateoas/dist/serverErrors');

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Request = Nested.Model.extend({
    defaults: {
        username: String.value(null).has.check(_auroraJavascriptUtils.validator.notEmpty(), _auroraJavascriptUtils.validator.notEmpty().message),
        password: String.value(null).has.check(_auroraJavascriptUtils.validator.notEmpty(), _auroraJavascriptUtils.validator.notEmpty().message)
    },

    initialize: function initialize() {
        this.postInitialize();
    },
    postInitialize: function postInitialize() {
        (0, _serverErrors.addServerErrorsIntegration)(this);
    }
});

var CommandClass = (0, _callClassFactory.createCallClass)({ methodType: _MethodType.MethodType.COMMAND }, Request, Nested.Model.extend({}));

exports.default = CommandClass;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/authorization/AuthorizeByFirstFactorCommandClass.js
// module id = 1317
// module chunks = 118